var elStripe = {
  load:function(elementID,options={}){
    this.elementID = elementID;
    this.button = document.getElementById("paymentSubmit");
    this.options = { 
      updatePayment:false,
      ...options 
    };
    this.setupElement(); 
    elLoader.show("Loading Payment Form");

  },
  submit:async function(billingEmail){ 
    elLoader.show(this.options.updatePayment ? "Updating Payment Method" : "Processing Payment");
    if(elPromoCode.isFree){
      var result = {
        setupIntent:{
          status:"succeeded",
          id:true
        }
      }
     
    }
    else{

        var result = await this.stripe.confirmSetup({
          elements:this.elements,
          redirect:'if_required',
          confirmParams:{
          //  return_url:ELAJAX.url + "paymentProcess/"+EVENTHASH
          }
        });
    }


    if(result.setupIntent && result.setupIntent.status == "succeeded"){
      let clientSecret = result.setupIntent.client_secret;
      let ajaxURL = this.options.updatePayment ? ELAJAX.url+"payment/update/"+EVENTHASH : ELAJAX.url+"payment/process/"+EVENTHASH;
      elPromoCode.save();

      fetch(ajaxURL,{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "Accept":"application/json"
        },
        body:JSON.stringify({
          eventHash:EVENTHASH,
          plan:PLANID,
          billingEmail:billingEmail,
          promoCode:elPromoCode.promoCode,
          setupIntent:result.setupIntent.id
        })
      }).then(res=>res.json())
      .then(data=>{
        if(data.error){

          elLoader.hide();
          alert(data.message);
        }
        else{
          if(this.options.updatePayment){
            parent.location = ELAJAX.homeURL + "user/payments/"+EVENTHASH+"/updated";
          }
          else{
            parent.location = ELAJAX.homeURL + "event/"+EVENTHASH+"/posted";
          }
        }
      });
    }
    else{
      elLoader.hide();
      if(result.error){
        if(this.options.form){
          this.options.form.errorMessage(result.error.message);
        }
        else{
          alert(result.error.message);
        }
        
      }
      else{
        if(this.options.form){
          this.options.form.errorMessage("Unable to Process Payment");
        }
        else{
          alert("Unable to Process Payment");
        }
      }
    }

  },
  setupElement:async function(){
    const response = await fetch(ELAJAX.url+"payment/secret",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "Accept":"application/json"
      },
      body:JSON.stringify({
        eventHash:EVENTHASH,
        'id':hh2020Login.userData.id,
        'token':hh2020Login.userData.token
      })
    });
    const {clientSecret} = await response.json();
    this.stripe = Stripe('pk_live_r8vJ8gmxgfuDrCEcWVJpLeB6');
    this.elements = this.stripe.elements({
      clientSecret:clientSecret,
    });
    this.paymentElement = this.elements.create('payment');
    this.paymentElement.on('ready',()=>{
      elLoader.hide();
    });
    this.paymentElement.mount("#"+this.elementID);
    

  }
}
